import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/untappd': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M401.3 49.9c-79.8 160.1-84.6 152.5-87.9 173.2l-5.2 32.8c-1.9 12-6.6 23.5-13.7 33.4l-148.9 207.8c-7.6 10.6-20.4 16.2-33.4 14.6-40.3-5-77.8-32.2-95.3-68.5-5.7-11.8-4.5-25.8 3.1-36.4l148.9-207.9c7.1-9.9 16.4-18 27.2-23.7l29.3-15.5c18.5-9.8 9.7-11.9 135.6-138.9 1-4.8 1-7.3 3.6-8 3-0.7 6.6-1 6.3-4.6l-0.4-4.6c-0.2-1.9 1.3-3.6 3.2-3.6 4.5-0.1 13.2 1.2 25.6 10 12.3 8.9 16.4 16.8 17.7 21.1 0.6 1.8-0.6 3.7-2.4 4.2l-4.5 1.1c-3.4 0.9-2.5 4.4-2.3 7.4 0.1 2.8-2.3 3.6-6.5 6.1zM230.1 36.4c-3.2-0.8-8.2-1.2-6.8-5.4 1.3-4.3 5.4-12.2 17.7-21.1 12.4-8.9 21.1-10.1 25.6-10 4.2 0.1 3.1 4.9 2.8 8.2-0.3 3.6 3.3 3.8 6.3 4.6 2.6 0.7 2.6 3.3 3.6 8 9.1 9.2 17.6 17.9 25.6 26.1 1.3 1.4 1.2 3.5-0.1 4.9-15.9 16.4-29.3 30.6-40.5 42.6-1 1-2.6 0.8-3.3-0.5-6.9-13.5-14.3-28.1-22.2-44-4.3-2.5-6.6-3.3-6.4-6 0.2-3 1.1-6.5-2.3-7.4zM620 406.7c7.7 10.7 8.8 24.7 3.4 36.6-17.7 36.6-55.4 63.7-95.7 68.6-12.9 1.5-25.5-4.1-33.1-14.7l-148.9-207.9c-7.1-9.9-11.8-21.4-13.7-33.4-1.6-9.8-2-19.1-0.3-29.8 1.9-12 2.7-6 49-94.8 0.7-1.4 2.6-1.6 3.6-0.5 16.3 18 19.3 23 30.5 28.9 29.8 15.7 43.2 20.6 56.4 39.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/untappd.js
// module id = 1067
// module chunks = 0